import { graphql } from '@apollo/client/react/hoc';
import { NavigationItem } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import { verificationCountQuery } from '../../graphql/legacy-queries';

class VerificationsItem extends React.Component {
  state = {
    verifications: undefined,
  };

  static getDerivedStateFromProps(nextProps) {
    const { data } = nextProps;
    if (!data.loading && !data.error && data.currentUserQuery) {
      return { verifications: data.currentUserQuery.pendingVerificationsCount || undefined };
    }
    return null;
  }

  render() {
    return <NavigationItem badgeCount={this.state.verifications} {...this.props} />;
  }
}

VerificationsItem.propTypes = {
  data: PropTypes.object,
};

export default graphql(verificationCountQuery)(VerificationsItem);
